import { Container } from "../Container"
import { CopyFooter } from "../CopyFooter"
import { MdOutlineLocationOn, MdOutlineEmail } from "react-icons/md"
import { BsTelephone, BsGithub } from "react-icons/bs"
import { GrDocumentUser } from "react-icons/gr"
import { FaSitemap } from "react-icons/fa"
import { SocialLink } from "../Nav/SocialLink"
import { Link } from "react-router-dom"
import classNames from "classnames"
import styles from "./Footer.module.css"

export const Footer = () => {
  const phone = "07769 583 616"
  const email = "miketandy@protonmail.com"

  return (
    <footer className={styles.root}>
      <section>
        <Container>
          <div className={styles.grid}>
            <div>
              <h6>
                Site Links <FaSitemap />
              </h6>
              <ul className={styles.list}>
                <li>
                  <a href='#technology'>Technology</a>
                </li>
                <li>
                  <a href='#industry'>Industry</a>
                </li>
                <li>
                  <a href='#philosophy'>Philosophy</a>
                </li>
                <li>
                  <a href='#about'>About</a>
                </li>
              </ul>
            </div>
            <div>
              <h6>
                Call, text or Whatsapp <BsTelephone />
              </h6>
              <p>
                <a href={`tel:${phone}`}>{phone}</a>
              </p>
              <h6>
                Email <MdOutlineEmail />
              </h6>
              <p>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              <h6>
                Location <MdOutlineLocationOn />
              </h6>
              <p className={styles.location}>Cardiff, UK</p>
            </div>
            <div>
              <h6>
                Terms of Use <GrDocumentUser />
              </h6>
              <p>
                <Link to='/privacy'>Privacy</Link>
              </p>
              <p>
                <Link to='/cookies'>Cookies</Link>
              </p>
            </div>
            <div>
              <h6>
                Social Links <BsGithub />
              </h6>
              <ul className={classNames(styles.list, styles.listMb)}>
                <SocialLink to='https://github.com/mike1234-pixel'>
                  Github
                </SocialLink>
                <SocialLink to='https://www.linkedin.com/in/michael-tandy-1367b8234/'>
                  LinkedIn
                </SocialLink>
              </ul>
            </div>
          </div>
        </Container>
      </section>
      <CopyFooter />
    </footer>
  )
}
